import { render, staticRenderFns } from "./TFCases.vue?vue&type=template&id=9bfa6aa8&scoped=true&"
import script from "./TFCases.vue?vue&type=script&lang=js&"
export * from "./TFCases.vue?vue&type=script&lang=js&"
import style0 from "./TFCases.vue?vue&type=style&index=0&id=9bfa6aa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfa6aa8",
  null
  
)

export default component.exports